﻿import BabelPolyfill from 'babel-polyfill';
import Vue from 'vue';
import store from './store';
import DeliveryDate from './components/checkout/DeliveryDate.js';
import NemId from './blocks/nemidlogin-checkoutmodule.js';
import EPad from './blocks/EPad.js';

import AlertModal from './components/AlertModal.js';

import ChoosePreferedPaymentMethod from './components/checkout/ChoosePreferedPaymentMethod.js';
import BroadbandChange from './components/checkout/BroadbandProviderChange.js';
import MiniBasket from './components/checkout/MiniBasket.js';
import PhoneJack from './components/checkout/PhoneJack.js';
import AcceptTermsAndConditions from './components/checkout/AcceptTermsAndConditions.js';
import AcceptRegretConditions from './components/checkout/AcceptRegretConditions.js';

import OrderAddress from './components/checkout/OrderAddress.js';
import CreditCheck from './components/checkout/CreditCheck.js';
import FormSubmitButton from './components/checkout/FormSubmitButton.js';
import PersonalDetails from './components/checkout/PersonalDetails.js';
import ExistingCustomer from './components/checkout/ExistingCustomer.js';
import EmploymentAndAccomodation from './components/checkout/EmploymentAndAccomodation.js';
import ReceiptConfirmationSection from './components/checkout/ReceiptConfirmationSection.js';
import MyTeliaLogin from './components/checkout/MyTeliaLogin.js';

import OfferingPage from './components/OfferingPage.js';
import VASItem from './components/offeringpage/VASItem.js';

//Credit Account
import CustomerOrderInfo from './components/creditaccount/orderInfo.js';
import OrderItemsCreditAccount from './components/creditaccount/orderItems.js';
import CreditEvaluation from './components/creditaccount/creditEvaluation.js';
import PageNavigation from './components/creditaccount/pageNavigation.js';
import PBSInformation from './components/creditaccount/pbsInformation.js';
import OrderSummaryCreditAccount from './components/creditaccount/orderSummary.js';
import ContractTermsAndConditions from './components/creditaccount/contractTermsAndConditions.js';
import ContractsSigniture from './components/creditaccount/contractsSignature.js';

//Digital validation
import DivaNemId from './blocks/nemidlogin-digitalvalidationmodule.js';
import DivaEId from './blocks/eidlogin-digitalvalidationmodule.js';
import Authentication from './components/digitalvalidation/authentication.js';
import FormSubmitDiButton from './components/digitalvalidation/FormSubmitDiButton.js';
import Porting from './components/digitalvalidation/porting.js';
import Documents from './components/digitalvalidation/documents.js';
import OrderOverviewB2C from './components/digitalvalidation/orderOverviewB2C'
import PageOverviewB2C from './components/digitalvalidation/pageOverviewB2C'
import DeliveryAddressB2C from './components/digitalvalidation/deliveryAddressB2C';
import DivaCancelOrder from './components/digitalvalidation/divaCancelOrder.js';
import PORTINGB2C from './components/digitalvalidation/portingB2C'
import DocumentsB2C from './components/digitalvalidation/documentsB2C'
import PaymentActionsB2C from './components/digitalvalidation/paymentActionsB2C'

import Office365 from './components/Office365.js';
import SpotifyActivation from './components/SpotifyActivation.js'
import Vuelidate from 'vuelidate';

import * as OpenPositions from '../../js/blocks/OpenPositions.js';
var openPositionsBlock = OpenPositions.Init(Vue);
 
//Common generic components
import Icon from './components/common/Icon.js';
import DynamicIcon from './components/common/DynamicIcon.js';
import ServiceLogo from './components/common/ServiceLogo.js';
import ChecklistIconSuccess from './components/common/ChecklistIconSuccess.js';
import ChecklistIconFail from './components/common/ChecklistIconFail.js';


//Make them globally accesible
Vue.component('icon', Icon);
Vue.component('dynamic-icon', DynamicIcon);
Vue.component('service-logo', ServiceLogo);
Vue.component('checklist-icon-success', ChecklistIconSuccess);
Vue.component('checklist-icon-fail', ChecklistIconFail);

Vue.component('VASItem', VASItem);

Vue.use(Vuelidate);

//Need an ID on the/a root page for all modules (i.e. id="xwing")
if (document.getElementById('xwing')) {
    new Vue({
        el: '#xwing',
        components: {
            'ca-customer-order-info': CustomerOrderInfo,
            'ca-orderitems': OrderItemsCreditAccount,
            'ca-credit-evaluation': CreditEvaluation,
            'ca-page-navigation': PageNavigation,
            'ca-pbs-information': PBSInformation,
            'ca-order-summary': OrderSummaryCreditAccount,
            'ca-ctc': ContractTermsAndConditions,
            'ca-contracts-signature': ContractsSigniture,
            OfferingPage,
            CreditCheck,
            FormSubmitButton,
            FormSubmitDiButton,
            AcceptTermsAndConditions,
            AcceptRegretConditions,
            PersonalDetails,
            EmploymentAndAccomodation,
            ExistingCustomer,
            AlertModal,
            'existing-customer' :ExistingCustomer,
            'authentication': Authentication,
            'porting': Porting,
            'documents': Documents,
            'di-order-overview-b2c' : OrderOverviewB2C,
            'di-page-overview-b2c' : PageOverviewB2C,
            'di-delivery-address-b2c' : DeliveryAddressB2C,
            'di-porting-b2c' : PORTINGB2C,
            'di-documents-b2c' : DocumentsB2C,
            'di-payment-actions-b2c' : PaymentActionsB2C,
            'diva-cancel-order': DivaCancelOrder,
            'epad' : EPad,
            'deliverydate': DeliveryDate,
            'choosepreferedpaymentmethod': ChoosePreferedPaymentMethod, 
            'broadbandchange': BroadbandChange,
            'phonejack': PhoneJack,
            'orderAddress': OrderAddress,
            MiniBasket,
            'office365': Office365,
            ReceiptConfirmationSection,
            'my-telia-login': MyTeliaLogin
        }, 
        store
    })
} else if (document.getElementById('spotify')) {
  // Hack: due to target build script being the same as ecommerce
  new Vue({
    el: '#spotify',
    components: {
      'spotify-activation': SpotifyActivation,
    }
  })
}

if (document.getElementById('ecom-split')) {
    new Vue({
        el: '#ecom-split',
        data() {
            return {
                steps: {
                    START: 'start',
                    WEBSHOP_REDIRECT: 'webshop_redirect',
                    COMPLETE: 'complete'
                },
                step: null,
                returnUrl: '',
                return: false,
                opened: false,
                redirectUrl: '',
                sessioned: false
            }
        },
        computed: {
            behaviourEnabled() {
                return !this.sessioned && window.__APP.webshopRedirectEnabled;
            }
        },
        created() {
            this.restartFlow();
        },
        mounted() {
            document.addEventListener('DOMContentLoaded', this.domLoaded);
            TL.eventBus.addEventListener('modal-close', this.modalClosedHandler);
        },
        watch: {
            step(val) {
                if (val === this.steps.COMPLETE) {
                    window.location.href = this.returnUrl;
                }
            }
        },
        methods: {
            domLoaded: function (event) {
                this.sessioned = TL.storage.safeRead('shop', false);
                if (this.behaviourEnabled) {
                    for (var ls = document.links, numLinks = ls.length, i=0; i<numLinks; i++){
                        ls[i].addEventListener('click', this.linkClicked);
                    }
                } else {
                    var banner = document.getElementById('ecom-split-banner');
                    if (banner) {
                        banner.classList.remove('hide');
                    }
                }
            },
            linkClicked: function(event){
                if (this.opened) {
                    return;
                }

                try {
                    if (sessionStorage) {	
                        var url = event.currentTarget.href;
                        var isShop = event.currentTarget.host === 'shop.telia.dk';
                        var bypass = Boolean(TL.xhrGetParam('bypass', url) === "true");

                        if (isShop && !bypass) {
                            this.returnUrl = TL.xhrRemoveParam(['bypass', 'return', 'redirect'], url)
                            this.return = Boolean(TL.xhrGetParam('return', url) === "true");
                            this.redirectUrl = decodeURI(TL.xhrGetParam('redirect', url) || '');
                            this.opened = true;
                            
                            TL.settings.ELM_POPUP_CONTENT.appendChild(this.$el);
                            TL.settings.ELM_POPUP.classList.remove(TL.settings.hide);

                            event.stopImmediatePropagation();
                            event.preventDefault();
                        }
                    }
                } catch (error) {
                    // silence
                }
            },
            modalClosedHandler: function(e) {
                this.opened = false;
                this.restartFlow();
            },
            showStep(step) {
                this.step = step;
            },
            bypass() {
                TL.storage.safeWrite('shop', 'OLD');
                window.location.href = this.returnUrl;
            },
            redirect() {
                TL.storage.safeWrite('shop', 'NEW');
                var url = this.redirectUrl || window.__APP.webshopDefaultRedirectUrl;
                if (this.return) {
                    url += `?returnShopUrl=${encodeURIComponent(this.returnUrl)}`;
                }
                window.location.href = url;
            },
            restartFlow() {
                this.step = this.steps.START;
            }
        },
        beforeDestroy() {
            if (this.behaviourEnabled) {
                for (var ls = document.links, numLinks = ls.length, i=0; i<numLinks; i++){
                    ls[i].removeEventListener('click', this.linkClicked);
                }
            }
            TL.eventBus.removeEventListener('modal-close', this.modalClosedHandler);
        }
    })
}